var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-theme-provider',{attrs:{"dark":""}},[_c('base-section',{staticClass:"jean",attrs:{"id":"divider","space":"20"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }